<script setup lang="ts">
import { onMounted } from 'vue';
import {storeToRefs} from "pinia";
import {useBusinessRequestFormStore} from "@/pages/index/stores/business-request-form-store.ts";

const businessRequestFormStore = useBusinessRequestFormStore()
const {current_progress_percentage} = storeToRefs(businessRequestFormStore)

onMounted(() => {})

const showPercentageText = (step:string):boolean =>{
    return ['images','keywords','signup','login'].includes(step)
}

</script>

<template>
    <div style="width: 100%;">
        <div class="progress mx-5 my-2">
            <div class="progress-bar bg-warning"
                 role="progressbar"
                 :style="{ width: current_progress_percentage + '%'}"
                 :aria-valuenow="current_progress_percentage"
                 aria-valuemin="0"
                 aria-valuemax="100">
            </div>
        </div>
        <div class="" v-if="showPercentageText(businessRequestFormStore.current_context.toString())">
            <p class="m-0">{{ current_progress_percentage }}% complété</p>
        </div>
        <hr>
    </div>
</template>

<style scoped>
.progress {
    background-color: #fceacf;
}
</style>